import { createContext, useContext } from 'react';

import type { PwaUpdateState } from '@/components/pwa/usePwaUpdate';

export const PwaUpdateContext = createContext<PwaUpdateState | null>(null);

/** Update state shared by the header indicator and the PWA chrome; null outside PwaUpdateProvider. */
export function usePwaUpdateContext(): PwaUpdateState | null {
  return useContext(PwaUpdateContext);
}
